export const UPDATE_NEWSLETTER_PROCESS_ID = 'updateNewsletter';
